import shiftSettingSlice from './shift/shiftSettingSlice.js';
import itemGradeCountSettingSlice from './items-grades-counts/ItemsGradesCountSettingSlice.js';
import dashboardSlice from './dashboard/dashboardSlice.js';

const adminSlices = {
    dashboard: dashboardSlice,
    shiftSetting: shiftSettingSlice,
    itemGradeCountSetting: itemGradeCountSettingSlice
};

export default adminSlices;